import { CdkPortal, DomPortalOutlet, PortalOutlet } from '@angular/cdk/portal';
import { AfterViewInit, ApplicationRef, Component, ComponentFactoryResolver, Injector, OnDestroy, ViewChild } from '@angular/core';

@Component({
  selector: 'app-clear-cart-action',
  templateUrl: './clear-cart-action.component.html',
})
export class ClearCartActionComponent implements AfterViewInit, OnDestroy {
  private portalOutlet: PortalOutlet;
  @ViewChild(CdkPortal) portal;

  constructor(private componentFactoryResolver: ComponentFactoryResolver, private injector: Injector, private appRef: ApplicationRef) {}

  ngAfterViewInit(): void {
    const outletElement = document.querySelector('#clear-cart-action-container');
    if (outletElement) {
      this.portalOutlet = new DomPortalOutlet(document.querySelector('#clear-cart-action-container'), this.componentFactoryResolver, this.appRef, this.injector);
      this.portalOutlet.attach(this.portal);
    }
  }

  ngOnDestroy(): void {
    if (this.portalOutlet) {
      this.portalOutlet.detach();
    }
  }
}
